import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { getEntities } from '../utils/getEntities';
import { IVariableDAO, IVariableOption } from 'types/domain/variable';
import { ITagJoin } from 'types/domain/tag';
import { moduleVariableImage, moduleVariableName } from './variables';
import { IText } from 'types/domain/text';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => id || state.state[EntityTypes.VARIABLE];

export const selectVariable = createSelector([entity, id], (entity: IEntityReducer, id) => {
  return parseVariableDAO(entity, id);
});

export function parseVariableDAO(entity, id) {
  const variable = entity[EntityTypes.VARIABLE][id];

  if (!variable) return null;

  const text: IText = variable.textId ? entity[EntityTypes.TEXT][variable.textId] : null;

  return {
    ...variable,
    name: moduleVariableName(entity, variable) || variable.name || `#${variable.id}`,
    image: moduleVariableImage(entity, variable),
    text,
    tags: getEntities(entity, EntityTypes.TAG_JOIN, 'variableId', variable.id) as ITagJoin[],
    options: getEntities(entity, EntityTypes.VARIABLE_OPTION, 'variableId', variable.id) as IVariableOption[],
  } as IVariableDAO;
}
